import { createSelector } from 'reselect';
import dayjs from 'utils/dayjs';
import { comments } from 'constants/currency';

export const getMbComments = state => state.currency?.mbComments?.data;
export const getMbCommentsItemsParams = (state, params) => params;
export const makeGetMbCommentsItems = () => {
  return createSelector(
    getMbComments,
    getMbCommentsItemsParams,
    (items, { currentCurrency }) => {
      const code = (currentCurrency || '').toUpperCase();
      const currencyItems =
        items && Array.isArray(items[code]) ? items[code] : null;

      if (!currencyItems) {
        return [];
      }

      const validItems = currencyItems.filter(
        item => item && typeof item === 'object'
      );

      return validItems.map(
        (
          { date, datetime, bid, ask, comment, trendAsk, trendBid, isClose },
          index
        ) => {
          const parsedDatetime = dayjs(datetime, 'DD.MM.YYYY HH:mm').toDate();
          const isToday = dayjs().format('L') === date;

          return {
            status: isClose === '1' ? comments.CLOSED : comments.ACTIVE,
            pointDate: !isToday
              ? datetime
              : dayjs(parsedDatetime).format('HH:mm'),
            bid,
            ask,
            comment,
            isFirst: index === validItems.length - 1,
            trendAsk,
            trendBid,
          };
        }
      );
    }
  );
};

export const getMbCommentsItem = makeGetMbCommentsItems();
